document.addEventListener('DOMContentLoaded', () => {
  const cartRoot = document.querySelector('[data-cart-modern]');

  if (!cartRoot) return;

  const sectionId = cartRoot.dataset.sectionId;
  const form = document.getElementById('cart');
  const termsCheckbox = document.getElementById('CartTerms');
  const checkoutButton = document.querySelector('[data-cart-checkout]');

  const setLoading = (state) => {
    cartRoot.classList.toggle('is-loading', state);
  };

  const parseHTML = (html) => {
    const parser = new DOMParser();
    return parser.parseFromString(html, 'text/html');
  };

  const replaceSectionFromResponse = (sectionHTML) => {
    const parsed = parseHTML(sectionHTML);
    const nextSection = parsed.getElementById(sectionId);
    const currentSection = document.getElementById(sectionId);

    if (nextSection && currentSection) {
      currentSection.replaceWith(nextSection);
    }
  };

  const updateCart = async (payload) => {
    setLoading(true);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          ...payload,
          sections: sectionId,
          sections_url: '/cart'
        })
      });

      const data = await response.json();

      if (data.sections && data.sections[sectionId]) {
        replaceSectionFromResponse(data.sections[sectionId]);
      } else {
        window.location.reload();
      }
    } catch (error) {
      window.location.reload();
    }
  };

  document.addEventListener('click', async (event) => {
    const plusBtn = event.target.closest('[data-cart-qty-plus]');
    const minusBtn = event.target.closest('[data-cart-qty-minus]');
    const removeBtn = event.target.closest('[data-cart-remove]');

    if (plusBtn) {
      const line = plusBtn.dataset.line;
      const input = document.querySelector(`[data-cart-qty-input][data-line="${line}"]`);
      const nextQty = Math.max(0, parseInt(input.value || '0', 10) + 1);
      await updateCart({ line: Number(line), quantity: nextQty });
      return;
    }

    if (minusBtn) {
      const line = minusBtn.dataset.line;
      const input = document.querySelector(`[data-cart-qty-input][data-line="${line}"]`);
      const nextQty = Math.max(0, parseInt(input.value || '0', 10) - 1);
      await updateCart({ line: Number(line), quantity: nextQty });
      return;
    }

    if (removeBtn) {
      const line = removeBtn.dataset.line;
      await updateCart({ line: Number(line), quantity: 0 });
    }
  });

  document.addEventListener('change', async (event) => {
    const qtyInput = event.target.closest('[data-cart-qty-input]');
    if (!qtyInput) return;

    const line = qtyInput.dataset.line;
    const value = Math.max(0, parseInt(qtyInput.value || '0', 10));

    if (Number.isNaN(value)) {
      qtyInput.value = 1;
      return;
    }

    await updateCart({ line: Number(line), quantity: value });
  });

  if (checkoutButton && termsCheckbox) {
    checkoutButton.addEventListener('click', (event) => {
      if (!termsCheckbox.checked) {
        event.preventDefault();
        alert('Please agree with the terms and conditions before checkout.');
      }
    });
  }

  if (form) {
    form.addEventListener('submit', (event) => {
      const clicked = document.activeElement;

      if (
        clicked &&
        clicked.matches('[data-cart-checkout]') &&
        termsCheckbox &&
        !termsCheckbox.checked
      ) {
        event.preventDefault();
        alert('Please agree with the terms and conditions before checkout.');
      }
    });
  }
});